import React from 'react';
import { Observable } from 'rxjs';
import { FormattedMessage } from 'react-intl';

import { ModalService } from 'ui-components/services/modal-service';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages as genericErrorRetryContainerMessages } from '../../../containers/generic-error-retry-container/messages';
import { ErrorModal } from '../../../components/modals/error-modal';
import { messages } from './messages';

export const LaunchBulkUpdateRetryModal$ = () => {
  return Observable.create((observer) => {
    ModalService.launchModal({
      component: ErrorModal,
      props: {
        title: <FormattedMessage {...messages.bulkUpdateJobErrorTitle} />,
        message: <FormattedMessage {...messages.bulkUpdateJobErrorMessage} />,
        buttons: [
          {
            theme: THEME_CONSTANTS.tertiary,
            children: <FormattedMessage {...genericErrorRetryContainerMessages.cancel} />,
          },
          {
            theme: THEME_CONSTANTS.primary,
            children: <FormattedMessage {...genericErrorRetryContainerMessages.tryAgain} />,
            onClick: () => {
              observer.next();
            },
          },
        ],
      },
      onClose: () => observer.complete(),
    });
  });
};
